import React from "react";
import { MerchantSchema } from "@repo/validators";
import { toast } from "sonner";

import { api } from "~/lib/api";
import { Form, FormField, FormItem, FormLabel, useForm } from "../ui/form";
import { Input } from "../ui/input";

export default function MerchantForm() {
  const { mutate: createMerchant } = api.admin.createMerchant.useMutation();

  const form = useForm({
    schema: MerchantSchema(),
  });

  const handleSubmit = form.handleSubmit((data) => {
    createMerchant(data, {
      onSuccess() {
        form.reset({}, { keepValues: false });
        toast.success("Merchant created successfully");
      },
      onError(error) {
        toast.error(error.message);
      },
    });
  });
  return (
    <Form {...form}>
      <form
        id="merchant-form"
        onSubmit={handleSubmit}
        className="grid grid-cols-2 gap-4"
      >
        <FormField
          control={form.control}
          name="companyName"
          render={({ field }) => (
            <FormItem className="col-span-full">
              <FormLabel>Company Name</FormLabel>
              <Input {...field} placeholder="Company Name" />
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="email"
          render={({ field }) => (
            <FormItem className="col-span-full">
              <FormLabel>Company Email</FormLabel>
              <Input {...field} placeholder="Company Email" />
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="firstName"
          render={({ field }) => (
            <FormItem className="col-span-full">
              <FormLabel>Contact First name</FormLabel>
              <Input {...field} placeholder="Contact First Name" />
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="password"
          render={({ field }) => (
            <FormItem className="col-span-full">
              <FormLabel>Password</FormLabel>
              <Input {...field} placeholder="Password" />
            </FormItem>
          )}
        />
      </form>
    </Form>
  );
}
